import React from 'react';
import PerkItem from '../PerkItem/PerkItem';
import styles from './PerksListContainer.module.scss';
import { PerksList } from '../interfaces';

export interface PerksProps {
  perksList: PerksList;
}

const PerksListContainer: React.FC<PerksProps> = ({ perksList }) => {
  const renderList = perksList && perksList.length;
  return (
    <ul className={styles.plansPerksList}>
      {renderList &&  perksList.map((perk) => (
        <PerkItem
          key={`${perk.id}-${perk.perk}`}
          perk={perk.perk}
          included={perk.included}
          tooltip={perk.tooltip}
        />
      ))}
  </ul>
)}

export default PerksListContainer;
